import CustomButton from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import useToggle from "common/hooks/useToggle"
import ArticulosFilter from "features/Inventario/components/ArticulosFilter/ArticulosFilter"
import CatalogoViewItems from "features/Inventario/components/CatalogoViewItems/CatalogoViewItems"
import ShareCatalogo from "features/Inventario/components/ShareCatalogo/ShareCatalogo"
import { useState } from "react"
import { ArrowLeft } from "react-feather"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"

import "./viewCatalogo.scss"

const ViewCatalogo = ({
  categorias,
  fetchingArticulos,
  catalogo,
  articulosGroupedByCategoria,
  filterArticulos,
  isSharedCatalogo = false,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [showWithGrid, setShowWithGrid] = useState(true)
  const [showShareCatalogoModal, toggleShowShareCatalogoModal] =
    useToggle(false)
  useToggle(false)
  const history = useHistory()

  return (
    <div className='wrap-view-catalogo'>
      <div className='container-catalogos'>
        <div className='mb-3 d-flex align-items-center justify-content-between'>
          {!isSharedCatalogo ? (
            <>
              <span className='flex f-21'>
                <ArrowLeft
                  style={{ cursor: "pointer" }}
                  className='mr-1'
                  onClick={history.goBack}
                />

                <span>
                  {catalogo?.nombre} (
                  {Object.keys(articulosGroupedByCategoria).length})
                </span>
              </span>
              <CustomButton
                onClick={toggleShowShareCatalogoModal}
                className='tw-py-3 tw-px-6 !tw-bg-primary tw-cursor-pointer'
                label={`${t("catalogos.idView.labelCompartir")}`}
              />
            </>
          ) : (
            <span className='flex f-21'>
              {catalogo?.nombre} (
              {Object.keys(articulosGroupedByCategoria).length})
            </span>
          )}
        </div>

        <ArticulosFilter
          // @ts-expect-error TS(2322): Type '{ showDisplayModes: true; onDisplayWithGridM...
          showDisplayModes
          onDisplayWithGridMode={(gridMode: $TSMigrationFixMe) =>
            setShowWithGrid(gridMode)
          }
          onFilter={filterArticulos}
          categorias={categorias}
        />

        <CatalogoViewItems
          itemsLayout={!showWithGrid}
          categorias={articulosGroupedByCategoria}
          loading={fetchingArticulos}
        />
      </div>

      <Modal
        visible={showShareCatalogoModal}
        header={`${t("catalogo.isView.labelCompartir")}`}
        onHide={toggleShowShareCatalogoModal}
      >
        <ShareCatalogo
          onHide={toggleShowShareCatalogoModal}
          catalogo={catalogo}
        />
      </Modal>
    </div>
  )
}

export default ViewCatalogo
